import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LandingPagesAPI from 'dashboard/api/landingPages';

// Estado do site de landing pages compartilhado pelas telas (lista, editor
// de pagina e configuracoes do site).
export function useLandingPageSite() {
  const { t } = useI18n();

  const site = ref(null);
  const isLoading = ref(true);

  const pages = computed(() => site.value?.pages || []);
  const hasSite = computed(() => !!site.value);
  const isProvisioned = computed(() => site.value?.status === 'active');

  const apiError = error =>
    error?.response?.data?.error ||
    (error?.response?.data?.message || []).toString() ||
    t('LANDING_PAGES.GENERIC_ERROR');

  const fetchSite = async ({ silent = false } = {}) => {
    if (!silent) isLoading.value = true;
    try {
      const { data } = await LandingPagesAPI.get();
      site.value = data[0] || null;
    } catch {
      if (!silent) site.value = null;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    site,
    pages,
    isLoading,
    hasSite,
    isProvisioned,
    apiError,
    fetchSite,
  };
}
